import { lazy, Suspense } from "react";
import { createFileRoute, Navigate } from "@tanstack/react-router";

import { navButtonClassName } from "@/components/forms/form-styles";
import { useIntakeSession } from "@/components/questionnaire/intake-session";
import { firstIntakeStepId } from "@/lib/routes";

const QuestionnaireSubmitted = lazy(() =>
  import("@/components/questionnaire/questionnaire-submitted").then(
    (module) => ({ default: module.QuestionnaireSubmitted }),
  ),
);

export const Route = createFileRoute("/intake/submitted")({
  component: IntakeSubmittedPage,
});

function IntakeSubmittedPage() {
  const { submitted, startOver } = useIntakeSession();

  if (!submitted) {
    return (
      <Navigate to="/intake/$stepId" params={{ stepId: firstIntakeStepId() }} />
    );
  }

  return (
    <Suspense fallback={null}>
      <QuestionnaireSubmitted
        data={submitted}
        onStartOver={startOver}
        navButtonClassName={navButtonClassName}
      />
    </Suspense>
  );
}
